/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import FavoritesPage from '@bottlebooks/gatsby-theme-event/src/components/Favorites/FavoritesPage';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';

export default function Favorites({ data, ...rest }) {
  const localeConfigs = data.site.siteMetadata.locales;
  const locales = localeConfigs?.map((locale) => locale.locale);
  const localeConfig = localeConfigs?.find(
    (config) => (config.locale = data.event.locale)
  );
  return (
    <FavoritesPage locale={localeConfig.locale} locales={locales} {...rest} />
  );
}

export const fragment = graphql`
  query Favorites {
    site {
      siteMetadata {
        locales {
          locale
          segments {
            exhibitor
            product
          }
        }
      }
    }
    event {
      locale
    }
  }
`;
